import {
  emptyResponseSchema,
  pushConfigResponseSchema,
  pushTestResponseSchema,
  type PushSubscriptionInput,
} from "@tm/contracts";
import { apiRequest } from "./client";

export const pushApi = {
  /** The VAPID public key, or null when the server has push turned off. */
  async publicKey(signal?: AbortSignal): Promise<string | null> {
    const { publicKey } = await apiRequest("/me/push", {
      schema: pushConfigResponseSchema,
      signal,
    });
    return publicKey;
  },

  async subscribe(input: PushSubscriptionInput): Promise<void> {
    await apiRequest("/me/push/subscriptions", {
      method: "POST",
      body: input,
      schema: emptyResponseSchema,
    });
  },

  async unsubscribe(endpoint: string): Promise<void> {
    await apiRequest("/me/push/subscriptions/remove", {
      method: "POST",
      body: { endpoint },
      schema: emptyResponseSchema,
    });
  },

  /** Returns how many of this session's devices accepted the test message. */
  async sendTest(): Promise<number> {
    const { delivered } = await apiRequest("/me/push/test", {
      method: "POST",
      schema: pushTestResponseSchema,
    });
    return delivered;
  },
};
